<template>
  <v-wp-form class="margin-bottom-0" @submit="handleForm">
    <template v-if="success == false">
      <v-form-group class="m-b-15">
        <v-old-input
          alias="e-mail"
          validation-config="required|email"
          placeholder="Email Address"
          class="input-lg"
          type="text"
          name="emailAddress"
          v-model="emailAddress"
        />
      </v-form-group>
      <p class="text-danger" v-if="errorMessage != null">{{ errorMessage }}</p>
      <div class="login-buttons">
        <button type="submit" class="btn btn-success btn-block btn-lg">
          Reset password
        </button>
      </div>
    </template>
    <div class="alert alert-success fade in m-b-15" v-if="success == true">
      <strong>Success!</strong>
      We sent an email with instructions on how to reset your password
    </div>
  </v-wp-form>
</template>

<script>
import axios from "axios";
export default {
  data() {
    return {
      emailAddress: "",
      success: false,
      errorMessage: null
    };
  },

  methods: {
    handleForm(event) {
      this.errorMessage = null;
      axios
        .post("/api/operator/forgotpassword", {
          emailAddress: this.emailAddress
        })
        .then(response => {
          this.success = true;
          this.errorMessage = null;
          setInterval(function() {
            window.location.reload();
          }, 5000);
        })
        .catch(reason => {
          this.errorMessage = reason.getResultDescription();
        });
    }
  }
};
</script>
